<template>
    <article class="detail">
        <section class="mod">
            <h2 class="mod-tit mod-tit2">资金流向</h2>
            <p class="tips">
                资金流向=每日初始限额-每日剩余额度;反映当日{{
                    sourceId === "nxzj" ? "南向资金" : "北向资金"
                }}的实际使用额度,包含实际成交的净流入额和未成交的委买额。
            </p>
            <div class="chart chart-today" id="lineSouth1"></div>
            <div class="chart-info flex">
                <div>
                    <span class="dot dot-blue">{{
                        sourceId === "bxzj" ? "沪股通" : "港股通（沪）"
                    }}</span
                    ><strong :class="chartInfo.zjlx.hgt_lr | formateRedGreen"
                        >{{ chartInfo.zjlx.hgt_lr | num }}亿</strong
                    >
                </div>
                <div>
                    <span class="dot dot-org">{{
                        sourceId === "bxzj" ? "深股通" : "港股通（深）"
                    }}</span
                    ><strong :class="chartInfo.zjlx.sgt_lr | formateRedGreen"
                        >{{ chartInfo.zjlx.sgt_lr | num }}亿</strong
                    >
                </div>
                <div>
                    <span class="dot dot-dark">{{
                        sourceId === "nxzj" ? "南向资金" : "北向资金"
                    }}</span
                    ><strong :class="chartInfo.zjlx.bxzjlr | formateRedGreen"
                        >{{ chartInfo.zjlx.bxzjlr | num }}亿</strong
                    >
                </div>
            </div>
        </section>
        <section class="mod">
            <h2 class="mod-tit mod-tit2">资金净流入</h2>
            <p class="tips">
                资金净流入=当日买入成交总额-当日卖出成交总额。反映当日{{
                    sourceId === "nxzj" ? "南向资金" : "北向资金"
                }}的实际流入流出情况。
            </p>
            <div class="chart chart-today" id="lineSouth2"></div>
            <div class="chart-info flex">
                <div>
                    <span class="dot dot-blue">{{
                        sourceId === "bxzj" ? "沪股通" : "港股通（沪）"
                    }}</span
                    ><strong :class="chartInfo.zjjlr.hgt_jlr | formateRedGreen"
                        >{{ chartInfo.zjjlr.hgt_jlr | num }}亿</strong
                    >
                </div>
                <div>
                    <span class="dot dot-org">{{
                        sourceId === "bxzj" ? "深股通" : "港股通（深）"
                    }}</span
                    ><strong :class="chartInfo.zjjlr.sgt_jlr | formateRedGreen"
                        >{{ chartInfo.zjjlr.sgt_jlr | num }}亿</strong
                    >
                </div>
                <div>
                    <span class="dot dot-dark">两市合计</span
                    ><strong :class="chartInfo.zjjlr.bxzjjlr | formateRedGreen"
                        >{{ chartInfo.zjjlr.bxzjjlr | num }}亿</strong
                    >
                </div>
            </div>
        </section>
        <section class="mod">
            <h2 class="mod-tit mod-tit2">资金余额</h2>
            <div class="chart chart-today" id="lineSouth3"></div>
            <div class="chart-info flex">
                <div>
                    <span class="dot dot-blue">{{
                        sourceId === "bxzj" ? "沪股通" : "港股通（沪）"
                    }}</span
                    ><strong :class="yeChartInfo.hgt_ye | formateRedGreen"
                        >{{ yeChartInfo.hgt_ye | num }}亿</strong
                    >
                </div>
                <div>
                    <span class="dot dot-org">{{
                        sourceId === "bxzj" ? "深股通" : "港股通（深）"
                    }}</span
                    ><strong :class="yeChartInfo.sgt_ye | formateRedGreen"
                        >{{ yeChartInfo.sgt_ye | num }}亿</strong
                    >
                </div>
                <!-- <div><span class="dot dot-dark">两市合计</span><strong class="ft-red">151.29亿</strong></div> -->
            </div>
        </section>
        <section class="mod">
            <h2 class="mod-tit mod-tit2">未成交委买资金</h2>
            <p class="tips">
                未成交委买资金=资金流向-资金净流入。反映算在当天{{
                    sourceId === "nxzj" ? "南向资金" : "北向资金"
                }}使用额度内，但是未实际成交的买单金额。
            </p>
            <div class="chart chart-today" id="lineSouth4"></div>
            <div class="chart-info flex">
                <div>
                    <span class="dot dot-blue">{{
                        sourceId === "bxzj" ? "沪股通" : "港股通（沪）"
                    }}</span
                    ><strong :class="chartInfo.wcj.hgt_wcj | formateRedGreen"
                        >{{ chartInfo.wcj.hgt_wcj | num }}亿</strong
                    >
                </div>
                <div>
                    <span class="dot dot-org">{{
                        sourceId === "bxzj" ? "深股通" : "港股通（深）"
                    }}</span
                    ><strong :class="chartInfo.wcj.sgt_wcj | formateRedGreen"
                        >{{ chartInfo.wcj.sgt_wcj | num }}亿</strong
                    >
                </div>
                <div>
                    <span class="dot dot-dark">两市合计</span
                    ><strong :class="chartInfo.wcj.bxzjwcj | formateRedGreen"
                        >{{ chartInfo.wcj.bxzjwcj | num }}亿</strong
                    >
                </div>
            </div>
        </section>
    </article>
</template>

<script>
import { bxzjmin, bxzjyemin, nxzjmin, nxzjyemin } from "@/api/index.js";
export default {
    name: "TodayNorthList",
    data() {
        return {
            bxzj_zjlx: [], //北向资金资金流向
            hgt_zjlx: [], //资金流向  沪股通
            sgt_zjlx: [], //资金流向  深股通
            bxzj_jlr: [], //北向资金净流入
            hgt_jlr: [], //沪股通净流入
            sgt_jlr: [], //深股通进流入
            bxzj_wcj: [], //北向资金未成交
            hgt_wcj: [], //沪股通未成交
            sgt_wcj: [], //深股通未成交
            hgt_ye: [], // 沪股通余额
            sgt_ye: [], // 深股通余额
            chartInfo: {
                zjlx: {
                    bxzjlr: "",
                    hgt_lr: "",
                    sgt_lr: "",
                },
                zjjlr: {
                    bxzjjlr: "",
                    hgt_jlr: "",
                    sgt_jlr: "",
                },
                wcj: {
                    bxzjwcj: "",
                    hgt_wcj: "",
                    sgt_wcj: "",
                },
            }, //资金流向、资金净流入、未成交委买资金 底部数据
            yeChartInfo: {
                gt_ye: "",
                sgt_ye: "",
            }, //余额数据

            timeInfo: [],
            MINUTES: 0, //沪深一天的交易时间
            AM_MINUTES: 0, //沪深上午交易时间
            sourceId: "", //判断页面来源
        };
    },
    filters: {
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        formatePrefixData: function (v) {
            if (v == undefined || v == null) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
        num: function (number) {
            if (number) {
                return (number / 100000000).toFixed(2);
            } else {
                return "0.00";
            }
        },
    },
    created() {
        let that = this;
        that.sourceId = that.$route.params.id
            ? that.$route.params.id
            : localStorage.getItem("sourceId");
        localStorage.setItem("sourceId", that.sourceId);
        if (this.sourceId === "bxzj") {
            that.MINUTES = 260;
            that.AM_MINUTES = 140;
        } else if (that.sourceId === "nxzj") {
            that.MINUTES = 370;
            that.AM_MINUTES = 180;
        }
        for (var i = 0; i <= that.MINUTES; i++) {
            that.timeInfo.push(that.convertXToTime(i));
        }
    },
    mounted: function () {
        let that = this;
        if (this.sourceId === "bxzj") {
            that.$nextTick(() => {
                that.getData();
                that.getBxye();
            });
        } else if (that.sourceId === "nxzj") {
            that.$nextTick(() => {
                that.getNxzjData();
                that.getNxzjYe();
            });
        }
    },
    methods: {
        addZero: function (str, length) {
            return (
                new Array(length - str.toString().length + 1).join("0") + str
            );
        },
        convertXToTime: function (x) {
            if (this.sourceId === "bxzj") {
                var startAm = new Date(1970, 1, 1, 9, 10, 0);
            } else {
                var startAm = new Date(1970, 1, 1, 9, 0, 0);
            }
            var startPm = new Date(1970, 1, 1, 13, 0, 0);
            var endXAm = this.AM_MINUTES; //上午交易时间段对应的最后一个x序列的值(2个小时,120分钟)
            var time = "";
            if (x <= endXAm) {
                time = new Date(+startAm + 60000 * x); //获得当前时间=起始时间 + 1分钟 * X
            } else {
                time = new Date(+startPm + 60000 * (x - endXAm)); //获得当前时间=起始时间 + 1分钟 * (X - 上午最后一个X - 1)
            }
            return [
                this.addZero(time.getHours(), 2),
                this.addZero(time.getMinutes(), 2),
            ].join(":");
        },
        // 获取北向资金资金流向 、资金净流入、未成交委买资金
        getData: function () {
            var _this = this;
            bxzjmin().then((res) => {
                if (res.data.err === 0) {
                    var response = res.data.data;
                    _this.getInfoData(response.desc);
                    var bxzj_zjlx,
                        hgt_zjlx,
                        sgt_zjlx,
                        bxzj_jlr,
                        hgt_jlr,
                        sgt_jlr,
                        bxzj_wcj,
                        hgt_wcj,
                        sgt_wcj;
                    var bxzjLength = response.bxzj.length;
                    if (bxzjLength < 20) {
                        _this.timeInfo = _this.timeInfo.slice(0, 21);
                    }
                    for (var i = 0; i < response.bxzj.length; i++) {
                        //资金流向
                        bxzj_zjlx = (response.bxzj[i] / 100000000).toFixed(2);
                        hgt_zjlx = (response.hgt[i] / 100000000).toFixed(2);
                        sgt_zjlx = (response.sgt[i] / 100000000).toFixed(2);

                        _this.bxzj_zjlx.push(bxzj_zjlx);
                        _this.hgt_zjlx.push(hgt_zjlx);
                        _this.sgt_zjlx.push(sgt_zjlx);

                        //资金净流入
                        bxzj_jlr = (response.bxzj_jlr[i] / 100000000).toFixed(
                            2
                        );
                        hgt_jlr = (response.hgt_jlr[i] / 100000000).toFixed(2);
                        sgt_jlr = (response.sgt_jlr[i] / 100000000).toFixed(2);
                        _this.bxzj_jlr.push(bxzj_jlr);
                        _this.hgt_jlr.push(hgt_jlr);
                        _this.sgt_jlr.push(sgt_jlr);

                        // 资金未成交
                        bxzj_wcj = (response.bxzj_wcj[i] / 100000000).toFixed(
                            2
                        );
                        hgt_wcj = (response.hgt_wcj[i] / 100000000).toFixed(2);
                        sgt_wcj = (response.sgt_wcj[i] / 100000000).toFixed(2);
                        _this.bxzj_wcj.push(bxzj_wcj);
                        _this.hgt_wcj.push(hgt_wcj);
                        _this.sgt_wcj.push(sgt_wcj);
                    }
                    var chartDom1 = document.getElementById("lineSouth1");
                    var chartDom2 = document.getElementById("lineSouth2");
                    var chartDom4 = document.getElementById("lineSouth4");
                    _this.drawLine(
                        chartDom1,
                        _this.bxzj_zjlx,
                        _this.hgt_zjlx,
                        _this.sgt_zjlx,
                        "北向资金"
                    );
                    _this.drawLine(
                        chartDom2,
                        _this.bxzj_jlr,
                        _this.hgt_jlr,
                        _this.sgt_jlr,
                        "两市合计"
                    );
                    _this.drawLine(
                        chartDom4,
                        _this.bxzj_wcj,
                        _this.hgt_wcj,
                        _this.sgt_wcj,
                        "两市合计"
                    );
                }
            });
        },
        // 获取北向资金资金余额
        getBxye: function () {
            var _this = this;
            bxzjyemin().then((res) => {
                var data = res.data.data;
                _this.getInfoDataYe(data.desc);
                var hgt_ye, sgt_ye;
                for (var i = 0; i < data.hgt_ye.length; i++) {
                    hgt_ye = (data.hgt_ye[i] / 100000000).toFixed(2);
                    sgt_ye = (data.sgt_ye[i] / 100000000).toFixed(2);
                    _this.hgt_ye.push(hgt_ye);
                    _this.sgt_ye.push(sgt_ye);
                }
                var chartDom3 = document.getElementById("lineSouth3");
                _this.drawLineYe(chartDom3, _this.hgt_ye, _this.sgt_ye);
            });
        },
        // 获取南向资金资金流向 、资金净流入、未成交委买资金
        getNxzjData: function () {
            var _this = this;
            nxzjmin().then((res) => {
                if (res.data.err === 0) {
                    var response = res.data.data;
                    _this.getInfoDataNxzj(response.desc);
                    var nxzj_zjlx,
                        hgt_zjlx,
                        sgt_zjlx,
                        nxzj_jlr,
                        hgt_jlr,
                        sgt_jlr,
                        nxzj_wcj,
                        hgt_wcj,
                        sgt_wcj;
                    var nxzjLength = response.nxzj.length;
                    if (nxzjLength < 30) {
                        _this.timeInfo = _this.timeInfo.slice(0, 31);
                    }
                    for (var i = 0; i < response.nxzj.length; i++) {
                        //资金流向
                        nxzj_zjlx = (response.nxzj[i] / 100000000).toFixed(2);
                        hgt_zjlx = (response.ggt_h[i] / 100000000).toFixed(2);
                        sgt_zjlx = (response.ggt_s[i] / 100000000).toFixed(2);

                        _this.bxzj_zjlx.push(nxzj_zjlx);
                        _this.hgt_zjlx.push(hgt_zjlx);
                        _this.sgt_zjlx.push(sgt_zjlx);

                        //资金净流入
                        nxzj_jlr = (response.nxzj_jlr[i] / 100000000).toFixed(
                            2
                        );
                        hgt_jlr = (response.ggt_h_jlr[i] / 100000000).toFixed(
                            2
                        );
                        sgt_jlr = (response.ggt_s_jlr[i] / 100000000).toFixed(
                            2
                        );
                        _this.bxzj_jlr.push(nxzj_jlr);
                        _this.hgt_jlr.push(hgt_jlr);
                        _this.sgt_jlr.push(sgt_jlr);

                        // 资金未成交
                        nxzj_wcj = (response.nxzj_wcj[i] / 100000000).toFixed(
                            2
                        );
                        hgt_wcj = (response.ggt_h_wcj[i] / 100000000).toFixed(
                            2
                        );
                        sgt_wcj = (response.ggt_s_wcj[i] / 100000000).toFixed(
                            2
                        );
                        _this.bxzj_wcj.push(nxzj_wcj);
                        _this.hgt_wcj.push(hgt_wcj);
                        _this.sgt_wcj.push(sgt_wcj);
                    }
                    var chartDom1 = document.getElementById("lineSouth1");
                    var chartDom2 = document.getElementById("lineSouth2");
                    var chartDom4 = document.getElementById("lineSouth4");
                    _this.drawLine(
                        chartDom1,
                        _this.bxzj_zjlx,
                        _this.hgt_zjlx,
                        _this.sgt_zjlx,
                        "南向资金"
                    );
                    _this.drawLine(
                        chartDom2,
                        _this.bxzj_jlr,
                        _this.hgt_jlr,
                        _this.sgt_jlr,
                        "两市合计"
                    );
                    _this.drawLine(
                        chartDom4,
                        _this.bxzj_wcj,
                        _this.hgt_wcj,
                        _this.sgt_wcj,
                        "两市合计"
                    );
                }
            });
        },
        // 获取南向资金资金余额
        getNxzjYe: function () {
            var _this = this;
            nxzjyemin().then((res) => {
                var data = res.data.data;
                _this.getInfoDataYeNxzj(data.desc);
                var hgt_ye, sgt_ye;
                for (var i = 0; i < data.ggt_h_ye.length; i++) {
                    hgt_ye = (data.ggt_h_ye[i] / 100000000).toFixed(2);
                    sgt_ye = (data.ggt_s_ye[i] / 100000000).toFixed(2);
                    _this.hgt_ye.push(hgt_ye);
                    _this.sgt_ye.push(sgt_ye);
                }
                var chartDom3 = document.getElementById("lineSouth3");
                _this.drawLineYe(chartDom3, _this.hgt_ye, _this.sgt_ye);
            });
        },
        drawLineYe: function (dam, yDataHgt, yDataSgt) {
            var _this = this;
            var myChart = this.$echarts.init(dam);
            var option;
            option = {
                color: ["#94C5EB", "#E6541E", "#493117"],
                tooltip: {
                    trigger: "axis",
                    confine: true,
                    triggerOn: "mousemove",
                    alwaysShowContent: false,
                    formatter: function (params) {
                        var string = "";
                        if (!isNaN(params[0].value)) {
                            string +=
                                params[0].marker +
                                params[0].seriesName +
                                "：" +
                                params[0].value +
                                "亿<br/>";
                        }
                        if (!isNaN(params[1].value)) {
                            string +=
                                params[1].marker +
                                params[1].seriesName +
                                "：" +
                                params[1].value +
                                "亿<br/>";
                        }
                        return string == ""
                            ? false
                            : params[0].name + "<br/>" + string;
                    },
                },
                grid: {
                    left: 0,
                    right: 10,
                    bottom: 0,
                    top: 25,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: _this.timeInfo,
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                    axisLabel: {
                        color: "#999",
                        interval: function (index) {
                            //index是x轴的坐标序号，name是坐标值
                            var timeLength = _this.timeInfo.length - 1;
                            if (index == 0) {
                                return true;
                            }
                            if (index == timeLength) {
                                return true;
                            }
                        },
                        formatter: function (value, index) {
                            //文本格式化
                            if (index === 0) {
                                return "{right|" + value + "}";
                            } else if (index === 4) {
                                return "{left|" + value + "}";
                            } else {
                                return "{center|" + value + "}";
                            }
                        },
                        rich: {
                            right: {
                                width: 80,
                                fontSize: 10,
                                align: "right",
                            },
                            left: {
                                width: 50,
                                fontSize: 10,
                                align: "left",
                            },
                            center: {
                                fontSize: 10,
                                align: "center",
                            },
                        },
                        padding: [0, 20, 0, 0],
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        splitNumber: 5,
                        gridIndex: 0,
                        axisLabel: {
                            fontSize: 12,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: "{value}亿",
                        },
                        splitLine: {
                            lineStyle: {
                                type: "dashed",
                                color: "#C8C8C8",
                            },
                        },
                        min: function (value) {
                            var minInfo = value.min - 10;
                            return Math.round(minInfo);
                        },
                        max: function (value) {
                            return Math.round(value.max + 10);
                        },
                    },
                    {
                        type: "value",
                        alignTicks: true,
                        position: "right",
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: "{value}%",
                        },
                        splitLine: { show: false },
                        min: function (value) {
                            if (value.min > 0) {
                                var minInfo = value.min - 20;
                            } else {
                                var minInfo = value.min + 20;
                            }

                            return Math.round(minInfo);
                        },
                        max: function (value) {
                            var maxInfo = value.max + 20;

                            return Math.round(maxInfo);
                        },
                    },
                ],
                series: [
                    {
                        name:
                            _this.sourceId === "bxzj"
                                ? "沪股通"
                                : "港股通（沪）",
                        type: "line",
                        // stack: 'Total',
                        symbol: "none",
                        data: yDataHgt,
                    },
                    {
                        name:
                            _this.sourceId === "bxzj"
                                ? "深股通"
                                : "港股通（深）",
                        type: "line",
                        // stack: 'Total',
                        symbol: "none",
                        data: yDataSgt,
                    },
                ],
            };
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        drawLine: function (dam, yDataHj, yDataHgt, yDataSgt, name) {
            var _this = this;
            var myChart = this.$echarts.init(dam);
            var option;
            option = {
                color: ["#94C5EB", "#E6541E", "#493117"],
                tooltip: {
                    trigger: "axis",
                    triggerOn: "mousemove",
                    confine: true,
                    alwaysShowContent: false,
                    formatter: function (params) {
                        var string = "";
                        if (!isNaN(params[0].value)) {
                            string +=
                                params[0].marker +
                                params[0].seriesName +
                                "：" +
                                params[0].value +
                                "亿<br/>";
                        }
                        if (!isNaN(params[1].value)) {
                            string +=
                                params[1].marker +
                                params[1].seriesName +
                                "：" +
                                params[1].value +
                                "亿<br/>";
                        }
                        if (!isNaN(params[2].value)) {
                            string +=
                                params[2].marker +
                                params[2].seriesName +
                                "：" +
                                params[2].value +
                                "亿<br/>";
                        }
                        return string == ""
                            ? false
                            : params[0].name + "<br/>" + string;
                    },
                },
                grid: {
                    left: 0,
                    right: 10,
                    bottom: 0,
                    top: 25,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: _this.timeInfo,
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                    axisLabel: {
                        color: "#999",
                        interval: function (index) {
                            //index是x轴的坐标序号，name是坐标值
                            var timeLength = _this.timeInfo.length - 1;
                            if (index == 0) {
                                return true;
                            }
                            if (index == timeLength) {
                                return true;
                            }
                        },
                        formatter: function (value, index) {
                            //文本格式化
                            if (index === 0) {
                                return "{right|" + value + "}";
                            } else if (index === 4) {
                                return "{left|" + value + "}";
                            } else {
                                return "{center|" + value + "}";
                            }
                        },
                        rich: {
                            right: {
                                width: 80,
                                fontSize: 10,
                                align: "right",
                            },
                            left: {
                                width: 50,
                                fontSize: 10,
                                align: "left",
                            },
                            center: {
                                fontSize: 10,
                                align: "center",
                            },
                        },
                        padding: [0, 20, 0, 0],
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        splitNumber: 5,
                        gridIndex: 0,
                        axisLabel: {
                            fontSize: 12,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: "{value}亿",
                        },
                        splitLine: {
                            lineStyle: {
                                type: "dashed",
                                color: "#C8C8C8",
                            },
                        },
                    },
                    {
                        type: "value",
                        alignTicks: true,
                        position: "right",
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: "{value}%",
                        },
                        splitLine: { show: false },
                    },
                ],
                series: [
                    {
                        name:
                            _this.sourceId === "bxzj"
                                ? "沪股通"
                                : "港股通（沪）",
                        type: "line",
                        symbol: "none",
                        data: yDataHgt,
                    },
                    {
                        name:
                            _this.sourceId === "bxzj"
                                ? "深股通"
                                : "港股通（深）",
                        type: "line",
                        symbol: "none",
                        data: yDataSgt,
                    },
                    {
                        name: name,
                        type: "line",
                        symbol: "none",
                        data: yDataHj,
                    },
                ],
            };
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        // 北向资金
        getInfoData: function (data) {
            var allData = {
                zjlx: {
                    bxzjlr: data.bxzjlr,
                    hgt_lr: data.hgt_lr,
                    sgt_lr: data.sgt_lr,
                },
                zjjlr: {
                    bxzjjlr: data.bxzjjlr,
                    hgt_jlr: data.hgt_jlr,
                    sgt_jlr: data.sgt_jlr,
                },
                wcj: {
                    bxzjwcj: data.bxzjwcj,
                    hgt_wcj: data.hgt_wcj,
                    sgt_wcj: data.sgt_wcj,
                },
            };
            this.chartInfo = allData;
        },
        getInfoDataYe: function (data) {
            var { yeChartInfo } = this;
            yeChartInfo = {
                hgt_ye: data.hgt_ye,
                sgt_ye: data.sgt_ye,
            };
            this.yeChartInfo = yeChartInfo;
        },
        // 南向资金
        getInfoDataNxzj: function (data) {
            var allData = {
                zjlx: {
                    bxzjlr: data.nxzjlr,
                    hgt_lr: data.ggt_h_lr,
                    sgt_lr: data.ggt_s_lr,
                },
                zjjlr: {
                    bxzjjlr: data.nxzjjlr,
                    hgt_jlr: data.ggt_h_jlr,
                    sgt_jlr: data.ggt_s_jlr,
                },
                wcj: {
                    bxzjwcj: data.nxzjwcj,
                    hgt_wcj: data.ggt_h_wcj,
                    sgt_wcj: data.ggt_s_wcj,
                },
            };
            this.chartInfo = allData;
        },
        getInfoDataYeNxzj: function (data) {
            var { yeChartInfo } = this;
            yeChartInfo = {
                hgt_ye: data.ggt_h_ye,
                sgt_ye: data.ggt_s_ye,
            };
            this.yeChartInfo = yeChartInfo;
        },
    },
};
</script>
